import React from 'react';

import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Navigator = (props) => {
    const { items } = props;

    return (
        <Breadcrumb className="mt-3">
            {items.map((item, i) =>
                !item.active ? (
                    <Breadcrumb.Item key={item.name + i} linkAs={Link} linkProps={{ to: item.link }}>
                        {item.name}
                    </Breadcrumb.Item>
                ) : (
                    <Breadcrumb.Item key={item.name + i} active>
                        {item.name}
                    </Breadcrumb.Item>
                ),
            )}
        </Breadcrumb>
    );
};

export default Navigator;
